import React from 'react';

import Box from '@atlaskit/primitives/box';
import Inline from '@atlaskit/primitives/inline';
import Stack from '@atlaskit/primitives/stack';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';

import { LoadingSkeleton } from '@townsquare/loading-skeleton';
import { SquareLoadingSkeleton } from '@townsquare/loading-skeleton/component';

const styles = xcss({
	borderWidth: 'border.width',
	borderStyle: 'solid',
	borderColor: 'color.border',
	borderRadius: 'radius.large',
	padding: 'space.200',
});

export function AgentSkeleton(): React.JSX.Element {
	return (
		<Box xcss={styles} testId="agent-browse-card-skeleton">
			<Stack grow="fill" space="space.200" spread="space-between">
				<Inline space="space.100" alignInline="start" alignBlock="center">
					<SquareLoadingSkeleton sideLengthPx={40} />
					<Stack space="space.100">
						<LoadingSkeleton width="150px" height="20px" />
						<LoadingSkeleton width="190px" height="20px" />
					</Stack>
				</Inline>
				<LoadingSkeleton height="40px" />
			</Stack>
		</Box>
	);
}
